import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit';

import { PromoPopupDescription } from '../../components/PromoPopupDescription';
import { promoOpenSelector, promoSelector } from '../../selectors/promo';
import { newbuildingIdSelector } from '../../selectors/newbuilding';
import { closePromo } from '../../slices';
import { trackCianMortgageClick } from '../PromoDetails/tracking';

export function PromoPopupContainer() {
  const [isOpenedJkList, setOpenedState] = React.useState(false);
  const isOpen = useSelector(promoOpenSelector);
  const promo = useSelector(promoSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);
  const dispatch = useDispatch();

  /* istanbul ignore next */
  const close = React.useCallback(() => {
    dispatch(closePromo());
  }, [dispatch]);

  /* istanbul ignore next */
  const onChangeOpenedState = React.useCallback(
    () => setOpenedState(!isOpenedJkList),
    [isOpenedJkList, setOpenedState],
  );

  /* istanbul ignore next */
  const handleMortgageClick = React.useCallback(() => {
    if (promo) {
      trackCianMortgageClick(promo, newbuildingId);
    }
  }, [promo, newbuildingId]);

  return (
    <ModalWindow open={isOpen} onClose={close} title={promo?.name as string}>
      {promo && (
        <PromoPopupDescription
          promo={promo}
          onCollapseClick={onChangeOpenedState}
          isCollapsed={isOpenedJkList}
          onMortgageClick={handleMortgageClick}
        />
      )}
    </ModalWindow>
  );
}
